import React from 'react';
import { Box, Checkbox, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import ViewWeekOutlinedIcon from '@mui/icons-material/ViewWeekOutlined';
import { ColumnConfigType } from 'shared/types';

type FilterColumnPropsType<DataType> = {
  columnConfig: ColumnConfigType<DataType>[];
  fieldVisibility: boolean[];
  setFieldVisibility: React.Dispatch<React.SetStateAction<boolean[]>>;
  style?: React.CSSProperties;
};

export const FilterColumn = <DataType,>({
  columnConfig,
  fieldVisibility,
  setFieldVisibility,
  style,
}: FilterColumnPropsType<DataType>) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpenFilterColumn = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseFilterColumn = () => {
    setAnchorEl(null);
  };

  const toggleFieldVisibility = (index: number) => {
    setFieldVisibility((prevVisibility) => {
      const updatedVisibility = [...prevVisibility];
      updatedVisibility[index] = !updatedVisibility[index];
      return updatedVisibility;
    });
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', ...style }}>
      <IconButton onClick={handleOpenFilterColumn}>
        <ViewWeekOutlinedIcon />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseFilterColumn}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 16px',
            minWidth: '220px',
          }}
        >
          <Typography sx={{ fontSize: '14px' }}>Показывать поля</Typography>
        </Box>
        {columnConfig.map((field, index) => (
          <MenuItem key={index}>
            <Checkbox
              checked={fieldVisibility[index]}
              onChange={() => toggleFieldVisibility(index)}
            />
            {field.name}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};
